
    <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
    <form (ngSubmit)="submit()" [formGroup]="form" novalidate>
      <h5 translate>guest_timed_popup.headline</h5>
      <p translate>guest_timed_popup.sub_headline</p>

      <app-form-input type="email" formControlName="email" [title]="'default.email' | translate"></app-form-input>

      <div class="_10px-spacer"></div>
      <app-form-button class="full-width primary __ga__btn-guest-timed-email" type="submit">
        {{ 'guest_timed_popup.button' | translate }}
      </app-form-button>
      <div class="_10px-spacer"></div>
      <app-form-button
        class="small full-width __ga__btn-guest-timed-signup"
        [routerLink]="['/v2', { outlets: { modal: 'signup' } }]"
        (click)="reject()"
      >
        {{ 'guest_timed_popup.button_secondary' | translate }}
      </app-form-button>
    </form>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/guest-modal-timed.component.ts.GuestModalTimedComponent.html